
import messages from '../translations';

let idiomas = new Object();

for(let lang in messages){
	idiomas[lang] = messages[lang].enlaces;
}

let langSelected = "es";

export function langdetector() {

	let path = location.pathname;

	if(path == "/" || path == "/404"){

		let localStorage = window.localStorage.getItem('language');

		let allowed = ['en', 'es'];

		if (!!!localStorage){
			langSelected = navigator.language.substring(0, 2);
			(!allowed.some(e => langSelected == e)) ? langSelected = 'en' : '';
		}else{
			(!Object.keys(idiomas).some(i => i == localStorage)) ? langSelected = "es" : langSelected = localStorage;
		}

	}else{

		path = '/'+path.split("/")[1];

		for(let lang in idiomas){

			let array = Object.entries(idiomas[lang]);


			(array.some(e => e[1] == path)) ? langSelected = lang : '';

		}

	}

	return langSelected;



}


// WEBPACK FOOTER //
// ./src/langdetector/index.js